import { apiService } from '@app/shared/services/api.service';
import type {
  ContractStatusResponse,
  ContractVersion,
  CreateContractVersionDto,
  SignContractDto,
  UserContractSignature,
} from '@neogeniux/api-contracts';

const NO_CONTRACT_STATUS: ContractStatusResponse = {
  needsSigning: false,
  currentVersion: null,
  lastSignedVersion: null,
};

function isNotFound(err: unknown): boolean {
  const e = err as {
    response?: { status?: number };
    status?: number;
    statusCode?: number;
  };
  return (
    e?.response?.status === 404 || e?.status === 404 || e?.statusCode === 404
  );
}

export const contractService = {
  getCurrent: async (): Promise<ContractVersion | null> => {
    try {
      return await apiService.getInstance().get('/contracts/current');
    } catch (err) {
      if (isNotFound(err)) return null;
      throw err;
    }
  },

  getMyStatus: async (): Promise<ContractStatusResponse> => {
    try {
      return await apiService.getInstance().get('/contracts/me/status');
    } catch (err) {
      if (isNotFound(err)) return NO_CONTRACT_STATUS;
      throw err;
    }
  },

  getMyHistory: (): Promise<UserContractSignature[]> =>
    apiService.getInstance().get('/contracts/me/history'),

  sign: (payload: SignContractDto): Promise<UserContractSignature> =>
    apiService.getInstance().post('/contracts/sign', payload),

  // sadmin
  listVersions: (): Promise<ContractVersion[]> =>
    apiService.getInstance().get('/contracts/sadmin/versions'),

  createVersion: (
    payload: CreateContractVersionDto
  ): Promise<ContractVersion> =>
    apiService.getInstance().post('/contracts/sadmin/versions', payload),

  activateVersion: (id: string): Promise<ContractVersion> =>
    apiService.getInstance().post(`/contracts/sadmin/versions/${id}/activate`),
};
